
// Template: resources/views/_components/admin/model-status-dropdown.blade.php

export default {

    name: "StatusDropdown",

    props: ['dataStatus'],

    data() {
        return {
            status: this.dataStatus
        }
    },

    computed: {
        isPublished() {
            return this.status === 'published';
        }
    },

    methods: {
        toggleStatus() {
            this.status = this.isPublished ? 'draft' : 'published';
        }
    }
};
